export default "__VITE_ASSET__CYe1Q_Zi__"